import {makeDeleteBatchRefundProcedure} from 'main/factories/usecases/private/refund/request/delete-batch-procedure';
import {DeleteBatchRefundProcedureParams} from 'domain/usecases/private/refund/request/delete-batch-procedure';

export async function deleteBatchProcedure(params: DeleteBatchRefundProcedureParams) {
	const deleteBatchRefundProcedure = makeDeleteBatchRefundProcedure(params);
	return deleteBatchRefundProcedure.delete();
}
